
const submissionManagement = {
    createCreditor: "New Creditor",
    editSearch: "Edit Search",
    submissionManagementTableTitle: "Claim Submissions",
    submissionManagementTableDescription:
      "Quick Search is case insensitive, and searches the following fields: Creditor Name, Creditor Description and CreditorID. Only creditors that include all of the search words or partial words will be displayed. For example 'jo smith' will find 'John A Smith' and also 'Blacksmith, Major'.",
    creditorDisablePopupDetails: {
      warningMessage:
        " Are you sure to disable this record : <strong>{{creditorName}}</strong>?",
      disabledMessage: "Creditor disabled successfully.",
      cannotDeletMessage:
        "Cannot delete an active creditor <strong>{{creditorName}}</strong>.",
    },
    header : {
        primaryTitle: "Submission Management",
        primaryDescription: "Lorem ipsum dolor sit amet consectetur. Pulvinar aliquet a odio sed aliquam ligula placerat massa. At interdum lectus auctor nibh dui massa tristique. Eget nisi potenti aenean ultrices nunc sit quam leo. Non risus donec et enim semper."
    },
    searchOptions: {
      basicSearch: "Basic Search",
      advancedSearch: "Advanced Search",
    },
    claimSubmissionView: {
        creditorDetailsTitle: "Creditor Details",
        assigneeDetailsTitle: "Assignee Details",
        documentsDetailsTitle: "Supporting Documents"
    },
    creditorColumnsDetails: {
      creditorId: "Creditor ID",
      name: "Name",
      totalClaims: "Total Claims",
      originalAmount: `Initial Amount {{unitName}}`,
      claimAmount: `Stage Amount {{unitName}}`,
      latestCreditorPositionAmount: `Unresolved Creditor Position {{unitName}}`,
      latestDebtorPositionAmount: `Unresolved Debtor Position {{unitName}}`,
      resolvedAmount: `Resolved Amount {{unitName}}`,
    },
    creditorBulkImport: {
      title: "Creditor Creation Upload",
      description: "Download template to create the import file",
      uploadLabel: "Upload Import File",
      uploadDescription:
        "The accepted document format are XLSX, XLS, CSV, PDF, DOC, DOCX, TXT, JPG, JPEG, PNG, GIF, TIFF OR ZIP. The maximum size per file is 250 MB.",
      uploadDescriptionForXlsx:
        "The accepted document format is XLSX only. The maximum size per file is 250 MB.",
    },
    creditorForm: {
      waningMessage:
        "Cannot delete the primary contact. Please select another contact as primary before deleting.",
      successfullyUpdatedMessage: "Successfully Updated",
      successfullyCreatedMessage: "Successfully Created",
      creditorNameAlreadyExists: "Creditor Name already exists",
      createFormTitle: "Creditor Setup",
      createFormDescription:
        "Before creating a new creditor, use the search functionality on the creditor tab to determine if the creditor already exists in this case. If you are creating a new creditor that has the same name as a different creditor, please ensure that you provide unique information in the Creditor Description field to distinquish the new creditor from the previously existing creditor.",
      tabPannelDetails: {
        creditorDetails: "Creditor Details",
        contactDetails: "Contact Details",
        creditorAttributes: "Creditor Attributes",
      },
      formLabelDetails: {
        radiobuttonsLabels: {
          individual: "Individual",
          organization: "Organization",
        },
        requiredFieldsMessages: {
          requiredPrimaryContact: "Primary contact is required",
          firstNameMessage: "First Name is required",
          additionalPayeeTypeMessage: "Additional Payee Type is required",
          lastNameMessage: "Last Name is required",
          businessNameMessage: "Business Name is required",
          mainMessage:
            "Please complete all required fields to continue. {{fieldNames}} cannot be left blank",
          contactDetailsMessage:
            "Please complete all required fields to continue. Contact Details required field cannot be left blank.",
        },
        creditorIdentification: "Creditor Identification",
        creditorId: "Creditor ID",
        prefix: "Prefix",
        primary: "Primary",
        name: "Name",
        displayName: "Display Name",
        creditorType: "Creditor Type",
        firstName: "First Name",
        lastName: "Last Name",
        businessName: "Business Name",
        description: "Description",
        relationshipToDebtor: "Relationship to Debtor",
        checkBoxPrimaryContact: "Set as Primary Contact",
        checkBoxAdditionalPayee: "Use as Additional Payeee",
        additionalPayeeType: "Additional Payee Type",
        email: "Email",
        phoneNumber: "Phone Number",
        fax: "Fax",
        relationshipToCreditor: "Relationship to Creditor",
        relationship: "Relationship",
        country: "Country",
        city: "City",
        address1: "Address 1",
        address2: "Address 2",
        address: "Address",
        payementDetails: "Payment Details",
        postalCode: "Postal Code",
        paymentCheckbox: "Add payment details for this contact",
        provinceState: "Province State",
        primaryContactDetails: "Primary Contact Details",
        otherContactDetails: "Other Contact Details",
        addAnotherContact: "Add Another Contact",
        institutionNumber: "Institution Number",
        transitNumber: "Transit Number",
        accountNumber: "Account Number",
        IBANNumber: "IBAN Number",
        SWIFTCode: "SWIFT Code",
        routingCode: "Routing Code",
        ACHCode: "ACH Code",
        creditorAttributes: "Creditor Attributes",
        attributeConfiguration: "Attribute Configuration",
      },
      reviewTitle: "Review",
      reviewDescription:
        "Please review and confirm the creditor information before saving.",
      contactDetailsTitle: "Contact Details",
      contactDetailsDescription:
        "Only one contact can be designated as the Primary Contact. The primary Contact's address and payment information will be used when generating distribution payments to this creditor. Additional contacts can be added, use the 'Relationship to Creditor' to denote the contacts role",
      creditorAttributesTitle: "Creditor Attributes",
      creditorAttributesDescription:
        "Creditor Attributes are used to record additional information about a creditor. Some Creditor Attributes may be mandatory. Only Creditor Attributes that are 'Required', or identified as 'Display during creation' will be presented here. All other attributes can be updated by editing the Creditor's Attributes after the creditor is created.",
      creditorDetailsTitle: "Creditor Details",
      creditorDetailsDescription:
        "If the creditor is an individual who is deceased, use the Prefix 'Estate of'",
    },
    creditorView: {
      payementDetails: "Payment Details",
      additionalPayee: "Additional Payee",
      additionalPayeeType: "Additional Payee Type",
      creditorViewTitle: "Creditor Details",
      creditorViewDescription:
        "This page presents Creditor Details. Use the Claim tab to access individual claims associated with this Creditor.",
      creditorAttributesTitle: "Creditor Attributes",
      contactDetailsTitle: "Contact Details",
      name: "Name: {{creditorName}}",
      tabPannelDetails: {
        summary: "Summary",
        claims: "Claims",
        attributeHistory: "Attribute History",
        distributions: "Distributions",
      },
    },
    creditorUpdate: {
      tabPannelDetails: {
        summary: "Summary",
        claims: "Claims",
      },
      title: "Creditor Details",
      description:
        "The Creditor is in edit mode, you may make changes to the Creditor's information including Attributes and Contacts. Use the 'Update' button below to save your changes.",
      creditorAttributesTitle: "Creditor Attributes",
      creditorContactDetailsTitle: "Contact Details",
    },
  
    creditorDocumentUpload: {
      documentPopup: {
        title: "Upload Documents",
        editTitle: "Edit Documents",
        subtitle:
          "Documents pertaining to the Creditor can be uploaded here. If the document relates only to a claim, it should be uploaded in the relevant claim.",
        documentType: "Document Type",
        fileName: "File Display Name",
        comment: "Comment",
        uploadText: "Click to upload or drag and drop",
        uploadDescription:
          "The accepted document format are XLSX, XLS, CSV, PDF, DOC, DOCX, TXT, JPG, JPEG, PNG, GIF, TIFF OR ZIP. The maximum size per file is 250 MB.",
        uploadDescriptionForXlsx:
          "The accepted document format is XLSX only. The maximum size per file is 250 MB.",
  
        displayName: "Display Name: ",
        upload: "Upload",
        edit: "Edit",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Are you sure you want to disable this document?",
      },
      creditorDocumentUploadTitle: "Documents",
      creditorDocumentUploadDescription:
        "Documents pertaining to the Creditor can be uploaded and accessed here. If the document relates only to a claim, it should be uploaded in the relevant claim.",
      tableColumnsDetails: {
        type: "Type",
        displayName: "File Display Name",
        comment: "Comment",
        createdBy: "Created By",
        receivedDate: "Received Date",
        claimId: "Claim ID",
      },
    },
    creditorSummaryBreadCrums: {
      backToCase: "Back to case",
    },
    creditorSummaryBanner: {
      bannerTitle: "Creditor",
      creditorId: "Creditor ID",
      distributionStatus: "Distribution Status",
      totalClaims: "Total Claims",
      creditorType: "Creditor Type",
    },
    creditorBasicSearch: {
      creditorName: "Creditor Name",
      creditorId: "Creditor ID",
      claimId: "Claim ID",
      debtorName: "Debtor Name",
      country: "Country",
      provinceState: "Province State",
      postalCode: "Postal Code",
      phoneNumber: "Phone Number",
      claimUpdatedDate: "Claim Updated Date",
    },
    creditorClaimTab: {
      tableTitle: "Claims",
      tableDescription:
        "Claims associated with this creditor are found here. Use the 'New Claim' button to add an additional claim for this Creditor.",
      moreOptions: {
        bulkUpload: "Bulk Upload",
        addNewClaim: "Add New Claim",
        bulkStatusUpdate: "Bulk Status Update",
        export: "Export",
      },
      tableColumnsDetails: {
        claimId: "Claim ID",
        assignee: "Assignee",
        unResolvedCreditorAmount: `Unresolved Creditor Position {{unitName}}`,
        unResolvedDebtorAmount: `Unresolved Debtor Position {{unitName}}`,
        resolvedAmount: `Resolved Amount {{unitName}}`,
        Stage: "Stage",
        actionStatus: "Action Status",
        lastUpdated: "Last updated",
        originalAmount: `Initial Amount {{unitName}}`,
        currentAmount: `Stage Amount {{unitName}}`,
      },
    },
    creditorAttributeTab: {
      tableTitle: "Attribute History",
      tableDescription:
        "This table provides a history of changes to creditor attributes",
      tableColumnsDetails: {
        attributeName: "Attribute Name",
  
        updatedOn: "Updated On",
  
        updatedBy: "Updated By",
  
        oldValue: "Old Value",
  
        newValue: "New Value",
      },
    },
    creditorDistributionTab: {
      tableTitle: "Net Payment",
      tableDescription: "Descriptive text that describes your page or content.",
      tableColumns: {
        paymentReference: "Payment Reference",
        accountName: "Account Name",
        subAccountName: "Sub Account Name",
        distributionName: "Distribution Name",
        amount: "Amount ({{unitName}})",
        prefix: "Prefix",
        status: "Status",
        payeeName: "PayeeName",
        paymentDate: "Payment Date",
        issueDate: "Issue Date",
        postedDate: "Posted Date",
      },
    },
  };
  
  export default submissionManagement;
  